import { render } from "./WorkflowIcon.vue?vue&type=template&id=31043739&scoped=true"
import script from "./WorkflowIcon.vue?vue&type=script&lang=js"
export * from "./WorkflowIcon.vue?vue&type=script&lang=js"

import "./WorkflowIcon.vue?vue&type=style&index=0&id=31043739&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31043739"]])

export default __exports__